<div class="profile-page">
    <p-toolbar styleClass="profile-toolbar">
        <ng-template #start>
            <div class="toolbar-actions">
                <p-button *ngIf="!editMode" label="Edit" icon="pi pi-pencil" (click)="startEdit()" />
                <ng-container *ngIf="editMode">
                    <p-button label="Save" icon="pi pi-save" (click)="saveProfile()" [loading]="saving" [disabled]="!isSaveEnabled() || saving || warehouseSwitchBusy" />
                    <p-button label="Cancel" icon="pi pi-times" severity="secondary" (click)="cancelEdit()" [disabled]="saving || warehouseSwitchBusy" />
                </ng-container>
            </div>
        </ng-template>
        <ng-template #end>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (click)="goBack()" />
        </ng-template>
    </p-toolbar>

    <div class="quick-switch-card" *ngIf="userProfile && !loading">
        <div class="quick-switch-title">Quick Warehouse Switch</div>
        <div class="quick-switch-subtitle">
            Click a warehouse to switch immediately (saved automatically). Use Edit and Save below only for manual changes to fields.
        </div>
        <div class="quick-switch-actions">
            <p-button
                *ngFor="let preset of warehousePresets"
                [label]="preset.label"
                [outlined]="selectedWarehouseId !== preset.id"
                [severity]="selectedWarehouseId === preset.id ? 'primary' : 'secondary'"
                (click)="switchWarehousePreset(preset)"
                [disabled]="saving || warehouseSwitchBusy"
            />
        </div>
    </div>

    <div class="table-box" *ngIf="userProfile">
        <p-table [value]="profileRows" responsiveLayout="scroll" class="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th>Field</th>
                    <th>Value</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td><i [class]="row.icon"></i> {{ row.label }}</td>
                    <td>
                        <ng-container [ngSwitch]="row.key">
                            <ng-container *ngSwitchCase="'mobile'">
                                <input *ngIf="editMode; else mobileView" pInputText type="text" [(ngModel)]="editProfile.mobile" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #mobileView>{{ userProfile.mobile }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'company'">
                                <input *ngIf="editMode; else companyView" pInputText type="text" [(ngModel)]="editProfile.company" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #companyView>{{ userProfile.company }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'division'">
                                <input *ngIf="editMode; else divisionView" pInputText type="text" [(ngModel)]="editProfile.division" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #divisionView>{{ userProfile.division }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'facility'">
                                <input *ngIf="editMode; else facilityView" pInputText type="text" [(ngModel)]="editProfile.facility" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #facilityView>{{ userProfile.facility }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'warehouse'">
                                <input *ngIf="editMode; else warehouseView" pInputText type="text" [(ngModel)]="editProfile.warehouse" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #warehouseView>{{ userProfile.warehouse }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'m3ResponsibleId'">
                                <input *ngIf="editMode; else m3View" pInputText type="text" [(ngModel)]="editProfile.m3ResponsibleId" [disabled]="saving || warehouseSwitchBusy" />
                                <ng-template #m3View>{{ userProfile.m3ResponsibleId }}</ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'createdAt'">
                                {{ userProfile.createdAt | date: 'medium' }}
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                {{ getProfileValue(row.key) }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-toast></p-toast>